import { zonedLocalToUtcIso } from "@/lib/datetime";

export function safeDate(value) {
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function dateKeyInTimeZone(value, timeZone) {
  const date = safeDate(value);
  if (!date) return "";
  try {
    const parts = new Intl.DateTimeFormat("en-GB", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(date);
    const get = (type) => parts.find(part => part.type === type)?.value || "";
    return `${get("year")}-${get("month")}-${get("day")}`;
  } catch {
    return date.toISOString().slice(0, 10);
  }
}

// Panoramica mostra solo "oggi" e i "prossimi 7 giorni": non serve l'intero
// storico prenotazioni, si chiede al server solo la finestra [oggi, oggi+6]
// (stessa tecnica di Calendario.js). Condivisa con la richiesta anticipata
// dell'avvio (lib/startup-prefetch.js): stessi parametri = stessa risposta.
export function overviewBookingParams(timeZone, now = new Date()) {
  const todayKey = dateKeyInTimeZone(now, timeZone);
  const weekEnd = new Date(now);
  weekEnd.setDate(now.getDate() + 6);
  const weekEndKey = dateKeyInTimeZone(weekEnd, timeZone);
  return {
    from_: zonedLocalToUtcIso(todayKey, "00:00", timeZone),
    to: zonedLocalToUtcIso(weekEndKey, "23:59", timeZone),
  };
}

/**
 * Fase 0 / UI.2 (F-12): "oggi" nel fuso dell'ATTIVITA' come `Date` locale a mezzanotte di quel giorno di calendario (le griglie del Calendario
 * lavorano su Date locali che rappresentano giorni). Con il browser in un altro fuso `new Date()`/`isToday` indicherebbero un giorno diverso da quello
 * in cui cadono le prenotazioni dell'attivita'. Fuso non valido: ricade sul giorno locale del browser, come prima.
 */
export function todayInTimeZone(timeZone, now = new Date()) {
  const key = dateKeyInTimeZone(now, timeZone);
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(key || "");
  return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(now.getFullYear(), now.getMonth(), now.getDate());
}
